module.exports = __webpack_public_path__ + "img/4HMLogo.2d53c813.png";